
import React from "react";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { ListCheck } from "lucide-react";

const QuickStartCard: React.FC = () => {
  return (
    <Card className="transition-all duration-300 hover:shadow-md">
      <CardHeader>
        <CardTitle className="flex items-center">
          <ListCheck className="h-5 w-5 mr-2 text-primary" />
          Quick Start
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <h4 className="font-medium">1. Access your dashboard</h4>
          <p className="text-sm text-muted-foreground">
            After completing this setup, you'll be taken to your dashboard where you can start using your AI assistant.
          </p>
        </div>
        
        <div className="space-y-2">
          <h4 className="font-medium">2. Connect integrations</h4>
          <p className="text-sm text-muted-foreground">
            Connect your favorite tools like Slack, email, and social media to maximize your AI assistant's abilities.
          </p>
        </div>
        
        <div className="space-y-2">
          <h4 className="font-medium">3. Create your first content</h4>
          <p className="text-sm text-muted-foreground">
            Use your AI assistant to create social media posts, email campaigns, or other content based on your business needs.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickStartCard;
